export const getTimeBetween = (age: number, lifetime: number, t: (text: string) => void) => {
  if (age && age > 1) {
    return `${age} ${t('days')}`;
  }

  if (lifetime < 24) {
    return `${lifetime} ${lifetime > 1 || lifetime === 0 ? t('Hours') : t('hour')}`;
  }

  const lifetimeDays = Math.floor(lifetime / 24);

  return `${lifetimeDays} ${lifetimeDays > 1 ? t('days') : t('day')}`;
};
